<template>
    <div>
      <header id="progress-bar" class="animate__animated">
        <div></div>
        <svg class="progress-line" id="line1" xmlns="http://www.w3.org/2000/svg" width="74px" height="2" viewBox="0 0 74 2">
            <line class="line" id="progress-1" data-name="Line 1" x2="72" transform="translate(1 1)" fill="none" style="stroke: var(--color-white);" stroke-linecap="round" stroke-width="2"/>
        </svg>

        <svg class="progress-line" xmlns="http://www.w3.org/2000/svg"  width="74px" height="2" viewBox="0 0 74 2">
            <line class="line" id="progress-2" data-name="Line 1" x2="72" transform="translate(1 1)" fill="none" stroke="#e4e4e4" stroke-linecap="round" stroke-width="2"/>
        </svg>

        <svg class="progress-line" xmlns="http://www.w3.org/2000/svg"  width="74px" height="2" viewBox="0 0 74 2">
            <line class="line" id="progress-3" data-name="Line 1" x2="72" transform="translate(1 1)" fill="none" stroke="#e4e4e4" stroke-linecap="round" stroke-width="2"/>
        </svg>

        <svg v-show="screen" class="progress-line2" xmlns="http://www.w3.org/2000/svg" width="74.414" height="50.725" viewBox="0 0 74.414 50.725">
            <path class="line" id="progress-4" data-name="Path 57881" d="M-11303.492-1345.272l6.03-6.351,14.442,23.058,15.925-48.724c0-.214,13.909,32.017,13.909,32.017l11.412-8.842,10.281,8.842h0" transform="translate(11304.906 1378.29)" fill="none" stroke="#e4e4e4" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
        </svg>

        <svg v-show="screen2" class="progress-line3" xmlns="http://www.w3.org/2000/svg" width="222" height="50.725" viewBox="0 0 400.5 50.726">
         <line id="Line_22" data-name="Line 22" x2="347" transform="translate(1 33.018)" fill="none" stroke="#fbfbfb" stroke-linecap="round" stroke-width="4"/>
          <path id="Path_57881" data-name="Path 57881" d="M-11303.494-1345.272l4.352-6.351,10.422,23.058,11.491-48.724c0-.214,10.037,32.017,10.037,32.017l8.235-8.842,7.418,8.842h0" transform="translate(11651.039 1378.29)" fill="none" stroke="#fbfbfb" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
        </svg>


        <div></div>
      </header>
    </div>
</template>

<script>

  export default {
    name: 'Progress-bar',
    data(){
      return{
        SectionIndex: 0,
        screen: false,
        screen2: true
      }
    },
    mounted(){
      this.updateProgress();
      window.addEventListener("resize", this.updateProgress);
    },
    methods:{
      updateProgress(){
      let scene = this.$parent.$options.name;
      let screenwidth =  document.body.clientWidth;
      let line1 = document.getElementById("progress-1");
      let line2 = document.getElementById("progress-2");
      let line3 = document.getElementById("progress-3");
      let line4 = document.getElementById("progress-4");
      let header = document.getElementById('progress-bar')

      let red = "var(--color-red)"
      let white = "var(--color-white)"
      
      if (screenwidth >= 1200) {
        this.screen = false;
        this.screen2 = true;
      }else{
        this.screen = true; this.screen2 = false;}

      //  console.log(scene)

      if (scene === "Scene1-yellow") {
        line1.style.stroke = red;
        header.classList.add("animation__fade");
      }else{line1.style.stroke = white; header.style.opacity = '1';}
      if (scene === "Scene2-yellow") {
        header.classList.remove("appear")
        line1.style.stroke = red
        line2.style.stroke = red
      }else{line2.style.stroke = white}
      if (scene === "Scene3-yellow") {
        line1.style.stroke = red
        line2.style.stroke = red
        line3.style.stroke = red
      }else{line3.style.stroke = white}
      if (scene === "Scene4-yellow") {
        line1.style.stroke = red
        line2.style.stroke = red
        line3.style.stroke = red
        line4.style.stroke = red
      }else{line4.style.stroke = white}
      if (scene == "end-red") {
        header.classList.add("appear")
      }else{header.classList.remove("appear")}

      

      }
    }
    }
</script>
<style scoped>

header{
    display: grid;

    margin: 20px;
    min-width: 318px;
    grid-template-columns: auto 72px 72px 72px 72px auto;
    grid-column-gap: 10px;

    margin-bottom: 10px;
    transition: all 0.5s ease-in-out;
}
.appear{
  opacity: 0;
   animation: appear 1s ease-in-out forwards;
}

.progress-line{
    margin-top: 31px;
    transition: all 0.5s ease-in-out;
}
.progress-line3{
  margin-top: 2px;
}
@keyframes appear {
    0%{opacity: 0;}
    100%{opacity: 1;}
  }
@media (min-width: 900px){
  header{
    grid-template-columns: auto 222px 222px 222px 222px auto;
    grid-column-gap: 30px;

  }
  .progress-line{
    transform: scale(3,1);
    transform-origin: left center;
    
  }
}

</style>